import { Button } from "@/components/ui/button";
import { COMMON_CLASSES } from "@/lib/jobConstants";
import { ArrowLeft } from "lucide-react";

interface JobNotFoundProps {
  onBack: () => void;
}

export function JobNotFound({ onBack }: JobNotFoundProps) {
  return (
    <div className="text-center py-12">
      <h2 className={`${COMMON_CLASSES.text.heading} mb-2`}>Job Not Found</h2>
      <p className={`${COMMON_CLASSES.text.subheading} mb-6`}>
        The job you're looking for doesn't exist or has been removed.
      </p>
      <Button onClick={onBack} className={COMMON_CLASSES.button.outline}>
        <ArrowLeft className="h-4 w-4 mr-2" />
        Back to Jobs
      </Button>
    </div>
  );
}
